import { List, Text } from '@mantine/core'

import { LegalPage } from './LegalPage'

/** `/cookies`: no sign-in needed. The source text is also kept in docs/legal/cookies.md; keep the two in sync. */
export function CookiesPage() {
  return (
    <LegalPage title="Cookies and local storage">
      <Text size="sm">
        Macrotide&apos;s web app uses no cookies at all — not for tracking, advertising, analytics, or anything else
        — and loads no third-party scripts or fonts. We do use your browser&apos;s local storage, strictly for what
        the app needs to work:
      </Text>
      <List size="sm">
        <List.Item>
          <b>Your sign-in session</b> — <code>macrotide.auth.session</code>
        </List.Item>
        <List.Item>
          <b>Your active gym</b> — <code>macrotide.activeGym</code>
        </List.Item>
        <List.Item>
          <b>The barcode cache</b>, so scanning the same product twice is instant — <code>macrotide.barcode.*</code>
        </List.Item>
        <List.Item>
          <b>Setup progress</b> — <code>macrotide.setupLater</code>, <code>macrotide.setupUnits</code>
        </List.Item>
        <List.Item>
          <b>Your light/dark/auto theme choice</b> — <code>mantine-color-scheme-value</code>
        </List.Item>
        <List.Item>
          <b>App settings from our server</b> (which features are on, maintenance notices), so the app works offline
          — <code>macrotide.config.cache</code>
        </List.Item>
        <List.Item>
          <b>In-app messages</b> and the ones you&apos;ve dismissed — <code>macrotide.messages.cache</code>,{' '}
          <code>macrotide.messages.dismissed</code>
        </List.Item>
        <List.Item>
          <b>Notification choices</b>, only if you turn notifications on — <code>macrotide.push.installationId</code>,{' '}
          <code>macrotide.push.categories</code>
        </List.Item>
      </List>
      <Text size="sm">
        Drafts of things you&apos;re editing (so a refresh doesn&apos;t lose them) live in{' '}
        <b>sessionStorage</b> under <code>macrotide.draft.*</code>, and are cleared as soon as the tab closes — they
        never reach another device or outlive the tab.
      </Text>
      <Text size="sm">
        <b>Notifications:</b> only if you turn on notifications in Settings, your browser registers a small
        background script (a service worker) from macrotide.ikarosdev.com and keeps a push subscription, so it can
        show our notifications; the app also remembers which in-app messages you&apos;ve dismissed. Turning
        notifications off removes the subscription.
      </Text>
      <Text size="sm">
        Signing out removes everything listed above from this browser and turns notifications off for it. Deleting
        your account does the same. You can also clear it any time in your browser&apos;s settings (&quot;clear site data&quot;).
      </Text>
      <Text size="sm">
        Our usage counts are made on our server from the requests the app already sends; nothing is stored in your
        browser for them.
      </Text>
      <Text size="sm">
        All of these are strictly necessary for the app to function, or remember a choice you made, under UK PECR /
        the ePrivacy Directive, so we don&apos;t need to show a cookie consent banner for them. If we ever add
        analytics, we&apos;ll ask first.
      </Text>
    </LegalPage>
  )
}
